(function(global) {
    function main() {
        overridePromoBanner();
    }

    function overridePromoBanner() {
        var currentCountryCode = window.geo.getCountryCodeFromCookie();

        var geoBanners = global.headerPromoGeoBanners;
        var html = '';

        if (!currentCountryCode || typeof geoBanners !== 'object') {
            return;
        }

        Object.keys(geoBanners).some(function(index) {
            var banner = geoBanners[index];

            if ('geo' in banner && typeof banner.geo === 'object') {
                banner.geo.some(function(bannerGeoCode) {
                    if (bannerGeoCode === currentCountryCode && banner.enabled) {
                        html = banner.html;
                        return true;
                    }
                });
            }

            return html;
        });

        if (currentCountryCode === 'JP') {
            delete global.headerPromoText;
        }

        if (html) {
            global.headerPromoText = html;
        }
    }

    $(main);
})(window.wrike);



// WEBPACK FOOTER //
// ./assets/js/common/modules/promo-banner.js